import { Formik } from 'formik'

import { initialValues } from './form'
import { accountManualSchema } from 'src/common/validations'
import { IAccountManualFormCreate } from 'src/types'
import { useAccountCreateCheck, useCreateAccountManual } from 'src/hooks'
import { CreateForm } from './form.component'

interface IProps {
  handleSelectItem: (id: string) => void
  handleClose: () => void
}

export const FormWrapper = ({ handleSelectItem, handleClose }: IProps) => {
  const { mutateAsync: createManually } = useCreateAccountManual()
  const { mutateAsync: checkExisting, data: existingAccount } = useAccountCreateCheck()

  const handleSubmit = async (values: IAccountManualFormCreate) => {
    if (!existingAccount) {
      const exists = await checkExisting({
        gln: null,
        website: values.website,
        account_holder: values.account_holder,
      })

      if (exists) return
    }

    const resp = await createManually(values)
    if (!resp) return

    handleSelectItem(resp.id)
    handleClose()
  }

  return (
    <Formik
      onSubmit={handleSubmit}
      validationSchema={accountManualSchema}
      initialValues={initialValues}
    >
      <CreateForm existingAccount={existingAccount || null} />
    </Formik>
  )
}
